<template>
  <transition name="modal">
    <div v-if="visible" class="modal-mask fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="modal-container bg-white rounded-lg p-6 max-w-2xl w-full relative">
        <button @click="$emit('close')" class="absolute top-2 right-2 text-gray-500 hover:text-black text-2xl">&times;</button>
        <div v-if="workHour">
          <div class="mb-2"><b>Korisnik:</b> {{ workHour.user ? workHour.user.full_name : '-' }}</div>
          <div class="mb-2"><b>Datum:</b> {{ workHour.date }}</div>
          <div class="mb-2"><b>Napomena:</b> {{ workHour.remark || '-' }}</div>
          <div class="mb-2"><b>Datum unosa:</b> {{ formatDate(workHour.created_at) }}</div>
          <div v-if="workHour.media && workHour.media.length">
            <div class="mb-2"><b>Fotografije:</b>
              <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2 max-h-[40vh] overflow-y-auto">
                <div v-for="(photo, idx) in workHour.media.filter(m => m.custom_properties && m.custom_properties.type === 'photo')"
                     :key="photo.id" class="flex flex-col items-center">
                  <img
                    :src="photo.url"
                    alt="Slika"
                    class="w-28 h-28 object-cover rounded cursor-pointer mb-1"
                    @click="openLightboxGallery(idx)"
                  >
                  <template v-if="photo.custom_properties && photo.custom_properties.gps">
                    <button
                      @click="openMap(photo.custom_properties.gps.lat, photo.custom_properties.gps.lon)"
                      class="mt-2 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded flex items-center gap-1 shadow transition-colors duration-150"
                      style="border:none;outline:none;cursor:pointer;"
                    >
                      <img src="/svg/map-marker.svg" alt="map" style="width:16px;height:16px;display:inline;vertical-align:middle;"/>
                      Prikaži na karti
                    </button>
                  </template>
                </div>
              </div>
            </div>
            <div class="mb-2" v-if="workHour.media.some(m => m.custom_properties && m.custom_properties.type === 'video')">
              <b>Video:</b>
              <ul>
                <li v-for="video in workHour.media.filter(m => m.custom_properties && m.custom_properties.type === 'video')" :key="video.id">
                  <a
                    :href="video.url"
                    download
                    class="mt-2 px-3 py-1 bg-green-600 hover:bg-green-700 text-white text-xs rounded flex items-center gap-1 shadow transition-colors duration-150"
                    style="border:none;outline:none;cursor:pointer;text-decoration:none;display:inline-flex;"
                  >
                    <img src="/svg/download-video.svg" alt="download" style="width:16px;height:16px;display:inline;vertical-align:middle;"/>
                    Preuzmi video
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'WorkHourDetailsModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    workHour: {
      type: Object,
      default: null
    }
  },
  methods: {
    openLightboxGallery(idx) {
      const photos = this.workHour.media.filter(m => m.custom_properties && m.custom_properties.type === 'photo');
      let current = idx;
      const lightbox = document.createElement('div');
      lightbox.className = 'fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50';
      lightbox.style.zIndex = 9999;
      const updateImage = () => {
        let arrows = '';
        if (photos.length > 1) {
          arrows = `
            <button id='prev' style='position:absolute;left:2vw;top:50%;transform:translateY(-50%);font-size:3rem;color:white;background:none;border:none;z-index:10;'>&#8592;</button>
            <button id='next' style='position:absolute;right:2vw;top:50%;transform:translateY(-50%);font-size:3rem;color:white;background:none;border:none;z-index:10;'>&#8594;</button>
          `;
        }
        lightbox.innerHTML = `
          ${arrows}
          <div style='display:flex;align-items:center;justify-content:center;width:100vw;height:100vh;'>
            <img src='${photos[current].url}' style='max-width:90vw;max-height:80vh;object-fit:contain;padding:1.5rem;'>
          </div>
          <button id='close' style='position:absolute;top:4vh;right:4vw;font-size:3rem;color:white;background:none;border:none;z-index:10;'>&times;</button>
        `;
        if (photos.length > 1) {
          lightbox.querySelector('#prev').onclick = (e) => { e.stopPropagation(); current = (current - 1 + photos.length) % photos.length; updateImage(); };
          lightbox.querySelector('#next').onclick = (e) => { e.stopPropagation(); current = (current + 1) % photos.length; updateImage(); };
        }
        lightbox.querySelector('#close').onclick = () => lightbox.remove();
      };
      updateImage();
      lightbox.onclick = (e) => { if (e.target === lightbox) lightbox.remove(); };
      document.body.appendChild(lightbox);
    },
    openMap(lat, lon) {
      window.open(`https://maps.google.com/?q=${lat},${lon}`, '_blank');
    },
    formatDate(date) {
      if (!date) return '';
      return window.moment
        ? window.moment(date).format('DD-MM-YYYY HH:mm:ss')
        : date;
    }
  }
}
</script>

<style scoped>
.modal-mask {
  transition: opacity 0.3s ease;
}
.modal-container {
  box-shadow: 0 2px 8px rgba(0,0,0,0.33);
}
</style>
